import {PayoffTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';


export function payoffTypeNameFilter(type: PayoffTypeEnum): string {
  switch (type) {
    case PayoffTypeEnum.Default: return i18n.t(LF.Default) as string;
    case PayoffTypeEnum.PayU: return 'PayU';
    default: return '';
  }
}
